import React from 'react'

export const Configuracion = () => {
  return (
    <span className="material-symbols-outlined">
      settings
    </span>
  )
}
